// utils/publicBrandRow.ts — SATU pintu baca baris brand publik per halaman.
// BrandFooter (footer) + loadBrandWarehouse (origin gudang) menembak RPC
// get_public_brand_info_by_id yang SAMA saat form dibuka → 2 roundtrip identik
// (insiden 2026-10-23). Janji in-flight dipakai ulang + hasil di-memo 120 dtk.
import { supabase } from '../supabase/client';

let inflight: Map<string, Promise<any>> | null = null;
let memo: { at: number; rows: Map<string, any> } | null = null;
const TTL_MS = 120_000;

function stores() {
    if (!inflight) inflight = new Map();
    if (!memo) memo = { at: 0, rows: new Map() };
    return { inflight: inflight as Map<string, Promise<any>>, memo: memo as { at: number; rows: Map<string, any> } };
}

/** Baris get_public_brand_info_by_id untuk 1 brand (di-memo, aman untuk anon). */
export function getPublicBrandRow(brandId: string): Promise<any | null> {
    if (!brandId) return Promise.resolve(null);
    const { inflight: fly, memo: mem } = stores();
    if (mem.rows.has(brandId) && Date.now() - mem.at < TTL_MS) {
        return Promise.resolve(mem.rows.get(brandId));
    }
    let p = fly.get(brandId);
    if (!p) {
        p = (async () => {
            try {
                const { data, error } = await supabase.rpc('get_public_brand_info_by_id', { p_brand_id: brandId });
                if (error || !data) return null;
                const row = Array.isArray(data) ? data[0] ?? null : data;
                return row;
            } catch {
                return null;
            } finally {
                fly.delete(brandId);
            }
        })();
        fly.set(brandId, p);
        p.then((row) => {
            mem.rows.set(brandId, row);
            mem.at = Date.now();
            if (mem.rows.size > 50) {
                const oldest = mem.rows.keys().next().value;
                if (oldest) mem.rows.delete(oldest);
            }
        });
    }
    return p;
}
